import { Alert, AlertDescription, AlertIcon, Flex } from "@chakra-ui/react";

const SanctionBanner = () => {
  return (
    <Flex width="100%" justifyContent="center" alignItems="center">
      <Alert
        status="warning"
        variant="subtle"
        flexDirection="row"
        alignItems="center"
        justifyContent="start"
        textAlign="center"
        borderRadius="16px"
        bg="#075A5A"
        color="#fff"
        width="100%"
        gap="1rem"
        style={{ opacity: 1 }}
      >
        <AlertIcon boxSize={7} mr={0} color={"#fff"} />
        <AlertDescription
          maxWidth="full"
          fontSize="14px"
          fontWeight="400"
          lineHeight="20px"
          textAlign="left"
        >
          Your wallet is not permitted to interact with Kelp due to compliance
          requirements.
        </AlertDescription>
      </Alert>
    </Flex>
  );
};

export default SanctionBanner;
